"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ColorInput;
Object.defineProperty(exports, "validations", {
  enumerable: true,
  get: function get() {
    return _validations["default"];
  }
});

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _components = require("../../components");

var _validations = _interopRequireDefault(require("./validations"));

var _excluded = ["config", "meta"];

function ColorInput(_ref) {
  var config = _ref.config,
      meta = _ref.meta,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_components.TextInput, (0, _extends2["default"])({
    config: config,
    meta: meta
  }, restProps));
}